import formats from './formats'

class purchasingRule {
    constructor(valueOrder = null, typePayment = 1, currentDate = null) {
        this.valueOrder = valueOrder;
        this.typePayment = typePayment
        this.currentDate = currentDate
    }

    formatParcel = (parcel) => {
        if (parcel?.length != 0) {
            const currentParcel = Array.from({ length: parcel }, (_, i) => i + 1)

            return currentParcel.filter(item => item !== 6)
        }
    }

    cardPayment = async (uf) => {
        let resultCardPeyment = { value: 0, parcel: 0 };

        try {
            if (this.typePayment === 1) {
                if (isNaN(this.valueOrder)) {
                    return resultCardPeyment;
                }

                if (uf === 'PB') {
                    if (this.valueOrder <= 200.00) {
                        resultCardPeyment.value = this.valueOrder;
                        resultCardPeyment.parcel = [1];
                        return resultCardPeyment;

                    } else if (this.valueOrder > 200.00 && this.valueOrder <= 299.99) {
                        resultCardPeyment.value = this.valueOrder;
                        resultCardPeyment.parcel = this.formatParcel(2);
                        return resultCardPeyment;

                    } else if (this.valueOrder > 299.99 && this.valueOrder <= 499.99) {
                        resultCardPeyment.value = this.valueOrder;
                        resultCardPeyment.parcel = this.formatParcel(3);
                        return resultCardPeyment;

                    } else if (this.valueOrder > 499.99 && this.valueOrder <= 699.99) {
                        resultCardPeyment.value = this.valueOrder;
                        resultCardPeyment.parcel = this.formatParcel(4);
                        return resultCardPeyment;

                    } else if (this.valueOrder > 699.99 && this.valueOrder <= 999.99) {
                        resultCardPeyment.value = this.valueOrder;
                        resultCardPeyment.parcel = this.formatParcel(5);
                        return resultCardPeyment;

                    } else {
                        resultCardPeyment.value = this.valueOrder;
                        resultCardPeyment.parcel = this.formatParcel(7);
                        return resultCardPeyment;
                    }

                } else if (uf === 'RN') {
                    if (this.valueOrder <= 100.00) {
                        resultCardPeyment.value = this.valueOrder;
                        resultCardPeyment.parcel = [1];
                        return resultCardPeyment;

                    } else if (this.valueOrder > 100.00 && this.valueOrder <= 400.00) {
                        resultCardPeyment.value = this.valueOrder;
                        resultCardPeyment.parcel = this.formatParcel(1);
                        return resultCardPeyment;

                    } else if (this.valueOrder > 400.00 && this.valueOrder <= 800.00) {
                        resultCardPeyment.value = this.valueOrder;
                        resultCardPeyment.parcel = this.formatParcel(2);
                        return resultCardPeyment;

                    } else if (this.valueOrder > 800.00 && this.valueOrder <= 1200.00) {
                        resultCardPeyment.value = this.valueOrder;
                        resultCardPeyment.parcel = this.formatParcel(3);
                        return resultCardPeyment;

                    } else {
                        resultCardPeyment.value = this.valueOrder;
                        resultCardPeyment.parcel = this.formatParcel(4);
                        return resultCardPeyment;
                    }
                }
            }

        } catch (err) {
            return err;
        }
    }

    ticketPayment = async (uf) => {
        let resultCardPeyment = { value: 0, parcel: 0, dates: [] };
        let resultCardPeymentRN = { value: 0, parcel: 0, dates: [] };
        var boletoRN = []
        try {

            if (this.typePayment === 3) {

                if (uf === 'PB') {
                    if (this.valueOrder <= 299.99) {
                        resultCardPeyment.value = this.valueOrder
                        resultCardPeyment.parcel = this.formatParcel(1)
                        resultCardPeyment.dates = { date: this.currentDate, parcel: 2, interval: 15 }
                        resultCardPeyment.completeDates = formats.gerarDatasPorIntervalo(this.currentDate, 2, 15)
                        return resultCardPeyment

                    } else if (this.valueOrder >= 300.00 && this.valueOrder <= 499.99) {
                        resultCardPeyment.value = this.valueOrder
                        resultCardPeyment.parcel = this.formatParcel(2)
                        resultCardPeyment.dates = { date: this.currentDate, parcel: 2, interval: 15 }
                        resultCardPeyment.completeDates = formats.gerarDatasPorIntervalo(this.currentDate, 2, 15)
                        return resultCardPeyment

                    } else if (this.valueOrder >= 500.00 && this.valueOrder <= 999.99) {
                        resultCardPeyment.value = this.valueOrder
                        resultCardPeyment.parcel = this.formatParcel(3)
                        resultCardPeyment.dates = { date: this.currentDate, parcel: 3, interval: 15 }
                        resultCardPeyment.completeDates = formats.gerarDatasPorIntervalo(this.currentDate, 3, 15)
                        return resultCardPeyment
                    } else if (this.valueOrder > 1000.00) {

                        resultCardPeyment.value = this.valueOrder
                        resultCardPeyment.parcel = this.formatParcel(3)
                        resultCardPeyment.dates = { date: this.currentDate, parcel: 3, interval: 20 }
                        resultCardPeyment.completeDates = formats.gerarDatasPorIntervalo(this.currentDate, 3, 20)
                        return resultCardPeyment
                    }
                } else if (uf === 'RN') {

                    if (this.valueOrder >= 100.00 && this.valueOrder <= 150.00) {
                        resultCardPeyment.value = this.valueOrder
                        resultCardPeyment.parcel = this.formatParcel(1)
                        resultCardPeyment.dates = { date: this.currentDate, parcel: 1, interval: 15 }
                        resultCardPeyment.completeDates = formats.gerarDatasPorIntervalo(this.currentDate, 1, 15)
                        resultCardPeyment.boletUltmate = false

                        resultCardPeymentRN.value = this.valueOrder
                        resultCardPeymentRN.parcel = this.formatParcel(1)
                        resultCardPeymentRN.dates = { date: this.currentDate, parcel: 1, interval: 30 }
                        resultCardPeymentRN.completeDates = formats.gerarDatasPorIntervalo(this.currentDate, 1, 30)
                        resultCardPeyment.boletUltmate = false
                        boletoRN.push(resultCardPeyment, resultCardPeymentRN)

                        return boletoRN

                    } else if (this.valueOrder >= 151.00 && this.valueOrder <= 600.00) {
                        resultCardPeyment.value = this.valueOrder
                        resultCardPeyment.parcel = this.formatParcel(2)
                        resultCardPeyment.dates = { date: this.currentDate, parcel: 2, interval: 15 }
                        resultCardPeyment.completeDates = formats.gerarDatasPorIntervalo(this.currentDate, 2, 15)
                        resultCardPeyment.boletUltmate = false
                        return resultCardPeyment

                    } else if (this.valueOrder > 601.00) {

                        resultCardPeyment.value = this.valueOrder
                        resultCardPeyment.parcel = this.formatParcel(5)
                        resultCardPeyment.dates = { date: this.currentDate, parcel: 5, interval: 15 }
                        resultCardPeyment.completeDates = formats.gerarDatasPorIntervaloAupRN(this.currentDate, 5)
                        resultCardPeyment.boletUltmate = true
                        return resultCardPeyment
                    }
                }
            }
        }
        catch (err) {
            return err
        }
    }

    pix = async () => { }

    paymentTheView = async () => { }
}

export default purchasingRule
